import dayjs from "dayjs";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: white;
  text-align: center;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const AnalogCenterDot = styled.div`
  background: #222;
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  border-radius: 50%;
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 2px solid #444;
`;

const HandAnalog = styled.div`
  position: absolute;
  background: ${({ color }) => color || "#444"};
  width: ${({ width }) => width || "4px"};
  height: ${({ height }) => height || "80px"};
  top: 50%;
  left: 50%;
  transform-origin: 50% 100%;
  transform: ${({ angle }) => `translate(-50%, -100%) rotate(${angle}deg)`};
  border-radius: 10px;
  z-index: 1;
`;

const AnalogNumber = styled.span`
  font-family: "NotoSansThaiLooped";
  font-size: ${({ fontSize }) => fontSize / 3}px;
  position: absolute;
  font-family: "Sarabun";
  font-weight: 700;
  transform: translate(-50%, -50%);
  top: ${({ top }) => top};
  left: ${({ left }) => left};
  color: black;
`;

const CLOCK_NUMBERS = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

const calculatePosition = ({ angle, radius }) => {
  const radian = (Math.PI / 180) * angle; // แปลงองศาเป็นเรเดียน
  const x = 50 + radius * Math.sin(radian); // ค่า x เปอร์เซ็นต์
  const y = 50 - radius * Math.cos(radian); // ค่า y เปอร์เซ็นต์
  return { x: `${x}%`, y: `${y}%` };
};

export const AnalogClock = ({ fontSize }) => {
  const [analogTime, setAnalogTime] = useState(dayjs());

  const analogNumbers = _.map(CLOCK_NUMBERS, (num, index) => {
    const angle = index * 30; // 30 องศาต่อ 1 เลข
    const { x, y } = calculatePosition({ angle, radius: 42 }); // ใช้ radius 42% คือ ระยะห่างจากวงกลม
    return { label: num, top: y, left: x };
  });

  const updateClock = () => {
    setAnalogTime(dayjs());
  };

  useEffect(() => {
    const timer = setInterval(updateClock, 1000);
    console.log("timer :>> ", timer);
    updateClock();
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Container>
      <HandAnalog
        color="#222"
        width={`${fontSize / 8}px`}
        height="20%"
        angle={analogTime.hour() * 30 + analogTime.minute() * 0.5}
      />
      <HandAnalog
        color="#444"
        width={`${fontSize / 12}px`}
        height="30%"
        angle={analogTime.minute() * 6}
      />
      <HandAnalog
        color="red"
        width={`${fontSize / 20}px`}
        height="38%"
        angle={analogTime.second() * 6}
      />

      <AnalogCenterDot width={fontSize / 5} height={fontSize / 5} />
      {_.map(analogNumbers, (num, index) => (
        <AnalogNumber
          key={index}
          top={num.top}
          left={num.left}
          fontSize={fontSize}
        >
          {num.label}
        </AnalogNumber>
      ))}
    </Container>
  );
};
